// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-o_fP","advertDetailContactGroup__header":"c-o_fQ","advertDetailContactGroup__value":"c-o_fR"};